import { Tween, Easing } from '@tweenjs/tween.js';
import { BonusGameView } from '../../view/bonus-game/BonusGameView';
import { LogoView } from '../../view/additional-components/LogoView';
import { BonusBuyWidget } from '../../view/widgets/BonusBuyWidget';
import { DoubleChanceWidget } from '../../view/widgets/DoubleChanceWidget';
import { DoubleChanceWidgetMobile } from '../../view/widgets/DoubleChanceWidgetMobile';

import { SpinButtons } from '../../view/action-buttons/SpinButtonsView';
import { BetAmount } from '../../view/action-buttons/BetAmountView';
import { QuestWidget } from '../../view/widgets/QuestWidget';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { MainBonusViewGrid } from '../../view/MainBonusViewGrid';

class ViewTransitions {
	constructor(ui, reels) {
		this.ui = ui;
		this.reels = reels;
	}
	animateReelEnter() {
		// this.reels.scale.y = 0;
		// new Tween(this.reels.scale)
		// 	.to({ y: 1 }, 1000)
		// 	.delay(200)
		// 	.easing(Easing.Bounce.InOut)
		// 	.start();
		for (let index = 0; index < 5; index++) {
			for (let j = 0; j < 3; j++) {
				this.reels.reels[index].items[j].y = -2000;
				new Tween(this.reels.reels[index].items[j])
					.to({ y: j * 228 }, 500)
					.delay((index + j) * 50)
					.easing(Easing.Bounce.InOut)
					.start();
			}
		}
	}
	animateIdleEnter(item, i) {
		if (item.name === COMPONENTS.STATUS_BAR) {
			return;
		} else {
			this.initY = this.ui[item.name].y;
			this.ui[item.name].y =
				-window.innerHeight - this.ui[item.name].getBounds().height;
			new Tween(this.ui[item.name])
				.to({ y: this.initY }, 100)
				.delay(300 + i * 50)
				.easing(Easing.Back.InOut)
				.onComplete(() => {
					// new Tween(this.ui[item.name])
					//     .to({ rotation: Math.random() < 0.5 ? -0.1 : 0.1 }, 100)
					//     .easing(Easing.Back.InOut)
					//     .onComplete(() => {
					//         new Tween(this.ui[item.name])
					//             .to({ rotation: 0 }, 500).delay(i * 50)
					//             .easing(Easing.Back.In)
					//             .start();
					//     }).start();
				})
				.start();
		}
	}

	addBonusRoundViews() {
		GameConfigs.uiComponent.gridController = new MainGridController(
			GameConfigs.uiComponent,
			MainBonusViewGrid
		);
		this.ui.alpha = 0;
		this.ui.addView(BonusGameView);
		GameConfigs.uiComponent.resize(window.CurrentSize.w, window.CurrentSize.h);
		// this.reels.start();
		setTimeout(() => {
			//   if (!GameConfigs.hasbonus) {
			//   }
			this.ui.alpha = 1;
		}, 100);

		if (GameConfigs.settings.game_animation) {
			// this.animateIdleViewExit()
			this.removeIdleViews();
		} else {
			this.removeIdleViews();
		}
	}

	addIdleGameViews() {
		this.ui.addView(LogoView);
		this.ui.addView(BonusBuyWidget);
		this.ui.addView(
			window.isMobile || window.isTablet
				? DoubleChanceWidgetMobile
				: DoubleChanceWidget
		);
		this.ui.addView(SpinButtons);
		this.ui.addView(BetAmount);
		this.ui.addView(QuestWidget);
	}

	removeBonusView() {
		if (GameConfigs.settings.game_animation) {
			new Tween(this.ui[COMPONENTS.BONUS_GAME])
				.to({ alpha: 0 }, 10)
				.easing(Easing.Back.InOut)
				.onComplete(() => {
					this.ui.removeView(this.ui[COMPONENTS.BONUS_GAME]);
					// this.ui.removeChild(this.ui[COMPONENTS.BONUS_GAME])
					// delete this.ui[COMPONENTS.BONUS_GAME]
				})
				.start();
		} else {
			this.ui.removeView(this.ui[COMPONENTS.BONUS_GAME]);
			// this.ui.removeChild(this.ui[COMPONENTS.BONUS_GAME])
			// delete this.ui[COMPONENTS.BONUS_GAME]
		}
	}
	removeIdleViews() {
		const uis = [
			this.ui[COMPONENTS.LOGO],
			this.ui[COMPONENTS.QUEST_WIDGET],
			this.ui[COMPONENTS.BONUS_BUY_WIDGET],
			this.ui[COMPONENTS.SPIN_BUTTONS],
			this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET],
			this.ui[COMPONENTS.BET_AMOUNT]
		];
		for (let i = 0; i < uis.length; i++) {
			//uis[i].alpha = 0
			if (uis[i]) {
				this.ui.removeView(uis[i]);
			}
			//this.ui.removeChild(uis[i])
			//delete uis[i]
		}
	}
	animateIdleViewExit() {
		new Tween(this.ui[COMPONENTS.LOGO])
			.to({ x: -this.ui[COMPONENTS.LOGO].position.x - window.innerWidth }, 1000)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.LOGO])
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.LOGO]);
						// this.ui.removeChild(this.ui[COMPONENTS.LOGO])
						// delete this.ui[COMPONENTS.LOGO]
					})
					.start();
			})
			.start();
		new Tween(this.ui[COMPONENTS.QUEST_WIDGET])
			.to(
				{ x: -this.ui[COMPONENTS.QUEST_WIDGET].position.x - window.innerWidth },
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.QUEST_WIDGET])
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.QUEST_WIDGET]);
					})
					.start();
			})
			.delay(150)
			.start();
		new Tween(this.ui[COMPONENTS.BONUS_BUY_WIDGET])
			.to(
				{
					x: window.innerWidth + this.ui[COMPONENTS.BONUS_BUY_WIDGET].position.x
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.BONUS_BUY_WIDGET])
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.BONUS_BUY_WIDGET]);
					})
					.start();
			})
			.start();
		new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_plus)
			.to(
				{
					x:
						this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_plus.position.x +
						(window.innerWidth -
							this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_plus.position.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_plus)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.BET_AMOUNT]);
					})
					.start();
			})
			.delay(300)
			.start();

		new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_minus)
			.to(
				{
					x:
						this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_minus.position.x +
						(window.innerWidth -
							this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_minus.position.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.ui_btn_minus)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.start();
			})
			.start();

		new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.BET_AMOUNT)
			.to(
				{
					x:
						this.ui[COMPONENTS.BET_AMOUNT].holder.BET_AMOUNT.position.x +
						(window.innerWidth -
							this.ui[COMPONENTS.BET_AMOUNT].holder.BET_AMOUNT.position.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.BET_AMOUNT].holder.BET_AMOUNT)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.start();
			})
			.delay(150)
			.start();
		new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].ui_btn_auto.item)
			.to(
				{
					x:
						this.ui[COMPONENTS.SPIN_BUTTONS].ui_btn_auto.item.position.x +
						(window.innerWidth -
							this.ui[COMPONENTS.SPIN_BUTTONS].ui_btn_auto.item.position.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].ui_btn_auto.item)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.start();
			})
			.start();
		new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].holder.ui_btn_fastplay)
			.to(
				{
					x:
						this.ui[COMPONENTS.SPIN_BUTTONS].holder.ui_btn_fastplay.position.x +
						(window.innerWidth +
							this.ui[COMPONENTS.SPIN_BUTTONS].holder.ui_btn_fastplay.position
								.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].holder.ui_btn_fastplay)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.start();
			})
			.delay(150)
			.start();
		new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].holder.spin_stop)
			.to(
				{
					x:
						this.ui[COMPONENTS.SPIN_BUTTONS].holder.spin_stop.position.x +
						(window.innerWidth -
							this.ui[COMPONENTS.SPIN_BUTTONS].holder.spin_stop.position.x)
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.SPIN_BUTTONS].holder.spin_stop)
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.SPIN_BUTTONS]);
						// this.ui.removeChild(this.ui[COMPONENTS.SPIN_BUTTONS])
						// delete this.ui[COMPONENTS.SPIN_BUTTONS]
					})
					.start();
			})
			.delay(300)
			.start();
		new Tween(this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET])
			.to(
				{
					x:
						window.innerWidth +
						this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET].position.x
				},
				1000
			)
			.easing(Easing.Back.InOut)
			.onUpdate(() => {
				new Tween(this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET])
					.to({ alpha: 0 }, 500)
					.easing(Easing.Back.Out)
					.delay(500)
					.onComplete(() => {
						this.ui.removeView(this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET]);
						// this.ui.removeChild(this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET])
						// delete this.ui[COMPONENTS.DOUBLE_CHANCE_WIDGET]
					})
					.start();
			})
			.delay(100)
			.start();
	}
}

export default ViewTransitions;
